import { isArrayNotEmpty } from 'utilities/JSUtil';
import URLConst from '../constants/URLConst';
import { fetchJSON, secureGET, securePUT } from '../utilities/FetchHelper';

class OnboardingContactService {

    getOnboardingContact(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_HOTEL_ONBOARDING_CONTACT_INITIAL
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    putOnboardingContact(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_HOTEL_ONBOARDING_CONTACT_INITIAL
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        return fetchJSON(url, { ...securePUT(), body: JSON.stringify(data) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }
}

export default new OnboardingContactService();